module.exports = __webpack_public_path__ + "img/40_37_026_490.c8f2f6a8.jpg";